export default function CTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-24 bg-navy-900 relative">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
          READY TO DISCUSS YOUR BUSINESS NEEDS?
        </h2>
        <p className="text-xl text-grey-300 mb-10 max-w-3xl mx-auto">
          Let's build the right solution for your assets and operations.
        </p>
        <button 
          onClick={() => scrollToSection('contact')}
          className="px-12 py-5 bg-navy-600 text-white rounded-lg hover:bg-navy-500 transition-all cursor-pointer font-semibold text-lg shadow-xl whitespace-nowrap hover:scale-105 transform"
        >
          Contact Our Team
        </button>
      </div>
    </section>
  );
}
